import { Avatar, Box, ClickAwayListener, FormLabel, type SxProps, Tooltip, tooltipClasses } from '@mui/material'
import { common } from '@mui/material/colors'
import { type MouseEvent, useState } from 'react'

const insertBreakableSpaces = (text: string): string => text.replace(/(?<!^)(?=[A-Z])/g, ' ')

interface LabelProps {
  required?: boolean
  name?: string
  isInline?: boolean
  maxWidth?: string
  labelText?: string
  labelBreaks?: boolean
  labelContent?: JSX.Element
  toolTipText?: string
  sx?: SxProps
  showRequiredText?: boolean
}

export const LabelWithToolTip = (props: LabelProps): JSX.Element => {
  const color = '#4591bb'
  const [hoverOpen, setHoverOpen] = useState(false)
  const [pinned, setPinned] = useState(false)
  const open = hoverOpen || pinned
  const handleTooltipClose = (): void => {
    setHoverOpen(false)
  }
  const handleTooltipOpen = (): void => {
    setHoverOpen(true)
  }
  const handleTooltipClick = (event: MouseEvent): void => {
    event.stopPropagation()
    setPinned(prev => !prev)
  }
  const handleClickAway = (): void => {
    setPinned(false)
  }

  const toolTip =
    <ClickAwayListener onClickAway={handleClickAway}>
      <Tooltip
        title={props.toolTipText}
        placement='top-start'
        onClose={handleTooltipClose}
        onOpen={handleTooltipOpen}
        open={open}
        arrow
        PopperProps={{
          disablePortal: true,
          sx: {
            [`& .${tooltipClasses.arrow}`]: {
              color
            },
            [`& .${tooltipClasses.tooltip}`]: {
              backgroundColor: color
            }
          },
          popperOptions: {
            modifiers: [
              {
                name: 'preventOverflow',
                enabled: true,
                options: {
                  altAxis: true,
                  altBoundary: true,
                  tether: true,
                  rootBoundary: 'document',
                  padding: 8
                }
              }

            ]
          }
        }}
      >
        <Box sx={{ float: 'right', ml: '5px' }}>
          <Avatar onClick={handleTooltipClick} sx={{ bgcolor: common.black, width: '18px', height: '18px', fontSize: '15px' }}>i</Avatar>
        </Box>
      </Tooltip>
    </ClickAwayListener>

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', minWidth: 0 }}>
      <FormLabel
        required={props.required === true && props.showRequiredText !== true}
        htmlFor={props.name}
        sx={{
          whiteSpace: 'break-spaces',
          alignSelf: props.isInline === true ? 'center' : '',
          color: 'black',
          maxWidth: props.maxWidth,
          minWidth: 0,
          overflowWrap: 'break-word',
          ...props.sx
        }}
      >
        {(props.toolTipText !== undefined) && (toolTip)}
        {props.labelContent ?? (props.labelText !== undefined ? ((props.labelBreaks ?? false) ? insertBreakableSpaces(props.labelText) : props.labelText) : undefined)}
      </FormLabel>
      {props.required !== true && props.showRequiredText === true && <Box sx={{ fontWeight: 200 }}>Optional</Box>}
      {props.required === true && props.showRequiredText === true && <Box sx={{ fontWeight: 400, color: '#E00000' }}>Required</Box>}
    </Box>
  )
}
